import type { ReactNode } from 'react';

export function ProgressBar({ done, total }: { done: number; total: number }): ReactNode {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div>
      <div className="mb-1 flex justify-between text-[11px] text-slate-400">
        <span>
          {done}/{total} abgeschlossen
        </span>
        <span>{pct}%</span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-700/50">
        <div
          className="h-full rounded-full bg-gradient-to-r from-amber-500 to-amber-400 shadow-[0_0_12px_rgba(251,191,36,0.5)] transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
